module.exports = __webpack_public_path__ + "Linearicons-Free.2781bf543c08d394dc78.svg";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.svg?w118d
// module id = ../../../../../src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.svg?w118d
// module chunks = styles